import type { GraphDiff, GraphIssue } from "@velizhanin-dev/bot-scenario"
import { apiClient } from "@/shared/api/client"
import { scenarioPath } from "./keys"

// --- публикация и версии ---

export interface PublishPreview {
	revision: number
	issues: GraphIssue[]
	diff: GraphDiff
	hasChanges: boolean
	canPublish: boolean
	latestVersionNumber: number | null
}

export interface ScenarioVersion {
	id: string
	number: number
	comment: string | null
	changeSummary: GraphDiff | null
	publishedById: string | null
	publishedAt: string
	publishedBy: {
		id: string
		firstName: string | null
		lastName: string | null
		username: string | null
	} | null
	isLatest: boolean
}

export const getPublishPreview = async (id: string) =>
	(await apiClient.get<PublishPreview>(scenarioPath(id, "/publish/preview"))).data

export const publishScenario = async (
	id: string,
	body: { baseRevision: number; comment?: string },
) =>
	(
		await apiClient.post<{ version: ScenarioVersion; warnings: GraphIssue[] }>(
			scenarioPath(id, "/publish"),
			body,
		)
	).data

export const listVersions = async (id: string) =>
	(await apiClient.get<ScenarioVersion[]>(scenarioPath(id, "/versions"))).data

export const restoreVersion = async (id: string, versionId: string, baseRevision: number) =>
	(
		await apiClient.post<{ restoredVersion: number; revision: number }>(
			scenarioPath(id, `/versions/${versionId}/restore`),
			{ baseRevision },
		)
	).data
